import {
    baseUrl,
    wxappid
} from './env';
const AppConsts = {
    userManagement: {
        defaultAdminUserName: 'admin'
    },
    localization: {
        defaultLocalizationSourceName: 'YunPaiWeiShang'
    },
    authorization: {
        encrptedAuthTokenName: 'enc_auth_token'
    },
    remoteServiceBaseUrl: baseUrl + '/',
    defaultPagesize: 20,
    wxappid:wxappid
}
export default AppConsts